import React, { useRef, useContext } from "react";

import { DispatchContext } from "bodycodi/cmap/app/components/common/context";

// components
import ServicePop from "bodycodi/cmap/app/components/terms/service";
import MarketingPop from "bodycodi/cmap/app/components/terms/marketing";
import PrivacyAgreePop from "../terms/privacyAgree";

type TernsServicePrep = {
  setAgree: Function;
  setAgreeMarketingYn: Function;
};

function TernsService({ setAgree, setAgreeMarketingYn }: TernsServicePrep) {
  const wrap = useRef<HTMLDivElement>(null);
  const allCheckBox = useRef<HTMLInputElement>(null);
  const { dispatch } = useContext(DispatchContext);

  const allcheck = () => {
    if (allCheckBox.current?.checked) {
      setAgree(true);
      setAgreeMarketingYn(true);
      const checkboxList = wrap.current?.querySelectorAll(".terns-service input[type='checkbox']")!;
      for (let i = 0; i < checkboxList.length; i++) {
        const checkbox = checkboxList[i] as HTMLInputElement;
        checkbox.checked = true;
      }
    } else {
      setAgree(false);
      setAgreeMarketingYn(true);
      const checkboxList = wrap.current?.querySelectorAll(".terns-service input[type='checkbox']")!;
      for (let i = 0; i < checkboxList.length; i++) {
        const checkbox = checkboxList[i] as HTMLInputElement;
        checkbox.checked = false;
      }
    }
  };

  const check = () => {
    const checkboxList = wrap.current?.querySelectorAll(".terns-service")!;
    let cnt = 0;
    let essemtinal = 0;
    let choice = 0;
    for (let i = 0; i < checkboxList.length; i++) {
      const checkbox = checkboxList[i];
      if (checkbox.classList.contains("essemtinal")) {
        const check = checkbox.querySelector("input[type='checkbox']") as HTMLInputElement;
        if (check.checked) {
          essemtinal++;
        }
      }
      if (checkbox.classList.contains("choice")) {
        const check = checkbox.querySelector("input[type='checkbox']") as HTMLInputElement;
        if (check.checked) {
          choice++;
        }
      }
      const chekc1 = checkbox.querySelector("input[type='checkbox']") as HTMLInputElement;
      if (chekc1.checked) {
        cnt++;
      }
    }
    if (essemtinal === 3) {
      setAgree(true);
    } else {
      setAgree(false);
    }
    if (choice === 1) {
      setAgreeMarketingYn(true);
    } else {
      setAgreeMarketingYn(false);
    }
    if (cnt === 4) {
      const all = wrap.current?.querySelector(
        ".terns-service-all input[type='checkbox']"
      ) as HTMLInputElement;
      all.checked = true;
    } else {
      const all = wrap.current?.querySelector(
        ".terns-service-all input[type='checkbox']"
      ) as HTMLInputElement;
      all.checked = false;
    }
  };

  const openPolicy = (i: number) => () => {
    switch (i) {
      case 0:
        dispatch({
          type: "POP_UP_OPEN",
          id: "SERVICE_DETAIL_POP",
          open: { serviceDetailPop: true },
        });
        return null;
      case 1:
        dispatch({
          type: "POP_UP_OPEN",
          id: "PRIVACY_AGREE_POP",
          open: { privacyAgreePop: true },
        });
        return null;
      case 2:
        dispatch({
          type: "POP_UP_OPEN",
          id: "MARKETING_DETAIL_POP",
          open: { marketingDetailPop: true },
        });
        return null;
    }
  };

  return (
    <>
      <div className="terns-service-wrap" ref={wrap}>
        <div className="terns-service-all" onClick={allcheck}>
          <label>
            <div className="title">모두 동의합니다.</div>
            <div className="check check-box-join">
              <input type="checkbox" ref={allCheckBox} />
              <span></span>
              <span></span>
            </div>
          </label>
        </div>
        <div className="terns-service essemtinal">
          <div className="title">[필수] 만 14세 이상입니다.</div>
          <label>
            <div className="check check-box-join" onClick={check}>
              <input type="checkbox" />
              <span></span>
              <span></span>
            </div>
          </label>
        </div>
        <div className="terns-service essemtinal">
          <div className="title" onClick={openPolicy(0)}>
            [필수] <span className="line">서비스 이용약관 동의</span>
          </div>
          <label>
            <div className="check check-box-join" onClick={check}>
              <input type="checkbox" />
              <span></span>
              <span></span>
            </div>
          </label>
        </div>
        <div className="terns-service essemtinal">
          <div className="title" onClick={openPolicy(1)}>
            [필수] <span className="line">개인정보 수집 및 이용동의</span>
          </div>
          <label>
            <div className="check check-box-join" onClick={check}>
              <input type="checkbox" />
              <span></span>
              <span></span>
            </div>
          </label>
        </div>
        <div className="terns-service choice">
          <div className="title" onClick={openPolicy(2)}>
            [선택] <span className="line">마케팅 목적 개인정보 수집 및 이용동의</span>
          </div>
          <label>
            <div className="check check-box-join" onClick={check}>
              <input type="checkbox" />
              <span></span>
              <span></span>
            </div>
          </label>
        </div>
      </div>
      <ServicePop />
      <PrivacyAgreePop />
      <MarketingPop />
    </>
  );
}

export default TernsService;
